module.exports = __webpack_public_path__ + "static/artboardng1-ed1430e840bc4cce5be6411b34b44fc1.png";